import { Injectable } from '@angular/core';
import { ApiService, GenericApiResponse, RequestBuilder, RequestTypeEnum } from '@client-monorepo/common/network';
import { BehaviorSubject, Observable } from 'rxjs';
import { CheckCardRequest } from '../models/check-card-request.interface';
import { CardCheckResponse } from '../models/card-check-response.interface';
import { PaymentResultInterface } from '@client-monorepo/payment/purchase';
import { CardToCardRequest } from '../models/card-to-card-request.interface';
import { CardPaymentConfig } from '../models/card-payment-config.interface';
import { CardPaymentConfigResponse } from '../models/card-payment-config-response';
import { CardRecommendationConfigResponse } from '../models/card-recommendation-config-response';
import { CardToCardRecommendationResponse } from '../models/card-to-card-recommendation-response';
import { DynamicPasswordRequest } from '@client-monorepo/daily-fintech/bank-card';
import { DynamicPasswordResponse } from '@client-monorepo/daily-fintech/bank-card';
import { CardVerifyRequest } from '../models/card-verify-request';

@Injectable({
  providedIn: 'root',
})
export class C2cApiService {
  /**
   * Default timeout of c2c APIs
   */
  timeout: BehaviorSubject<number> = new BehaviorSubject(30000);
  constructor(private apiService: ApiService) {}

  checkCardTransferKyc(params: CheckCardRequest): Observable<CardCheckResponse> {
    const request = new RequestBuilder(RequestTypeEnum.POST, 'cards/check', params);
    return this.apiService.call<CardCheckResponse>(request);
  }

  cardToCardTransfer(params: CardToCardRequest): Observable<PaymentResultInterface> {
    const header = { timeout: '' + this.timeout.getValue() };
    const request = new RequestBuilder(RequestTypeEnum.POST, 'payments/card', params);
    request.setHeader(header);
    return this.apiService.call<PaymentResultInterface>(request);
  }

  getAmountConfig(params: CardPaymentConfig): Observable<CardPaymentConfigResponse> {
    const request = new RequestBuilder(RequestTypeEnum.POST, 'payments/card/config', params);
    return this.apiService.call<CardPaymentConfigResponse>(request);
  }

  getRecommendationConfig(): Observable<CardRecommendationConfigResponse> {
    const request = new RequestBuilder(RequestTypeEnum.GET, `recommendations/4/config`);
    return this.apiService.call<CardRecommendationConfigResponse>(request);
  }

  getRecommendation(): Observable<CardToCardRecommendationResponse> {
    const request = new RequestBuilder(RequestTypeEnum.GET, `recommendations/4`);
    return this.apiService.call<CardToCardRecommendationResponse>(request);
  }

  deleteRecommendation(id: string): Observable<GenericApiResponse> {
    const request = new RequestBuilder(RequestTypeEnum.DELETE, `recommendations/4/${id}`);
    return this.apiService.call<GenericApiResponse>(request);
  }

  editRecommendation(params: any): Observable<GenericApiResponse> {
    const request = new RequestBuilder(RequestTypeEnum.PUT, `recommendations/4`, params);
    return this.apiService.call<GenericApiResponse>(request);
  }

  requestDynamicPassword(params: DynamicPasswordRequest, timeout?: number): Observable<DynamicPasswordResponse> {
    const request = new RequestBuilder(RequestTypeEnum.POST, 'cards/otp', params);
    return this.apiService.call<DynamicPasswordResponse>(request);
  }

  verifyCardApi(params: CardVerifyRequest): Observable<any> {
    const request = new RequestBuilder(RequestTypeEnum.POST, 'cards/verify', params);
    return this.apiService.call<any>(request);
  }
}
